import { useEffect, useRef, useState } from 'react';
import ErrorModal from '../../../../../../component/ErrorModal/ErrorModal';
import InputSelect from '../../../../../../component/inputSelect/InputSelect';
import { getProductBatchList, getProductList } from '../../../../../../services/products';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import {
	fetchInvoiceDetails,
	getInvoiceDetail,
	getInvoicesList,
} from '../../../../../../services/invoices';
import { fetchSalesReturnType } from '../../../../../../services/sales_return';
import { taxesCalculation } from '../../../../components/TaxesCalculation';
import { getDate } from '../../../../../../utils/dateUtils';

const SalesRetuenProductTable = ({
	initialRows,
	tableError,
	className,
	setTableError,
	productTable,
	setProductTable,
	columns,
	customerId,
}) => {
	const param = useParams();
	const id = param?.id;
	const [showError, setShowError] = useState(false);
	const [batchList, setBatchList] = useState([]);
	const inputRefs = useRef([]);
	const [productList, setProductList] = useState([]);
	const [returnTypeList, setReturnTypeList] = useState([]);
	const [invoiceList, setInvoiceList] = useState([]);
	const ErrorModalOpen = () => {
		setShowError(true);
	};

	const getToolTipData = (name) => {
		switch (name) {
			case 'return_type_id':
				return 'Return Type can not be empty.';
			case 'invoice_id':
				return 'Invoice Number can not be empty.';
			case 'product_name':
				return 'Product Name can not be empty.';
			case 'batch_no':
				return 'Batch No can not be empty';
			case 'expiry_date':
				return 'Expire date can not be empty';
			case 'mrp':
				return 'MRP can not be empty';
			case 'quantity':
				return 'Quantity can not be empty or 0';
			case 'amount':
				return `Amount can not empty`;
			default:
				return '';
		}
	};

	async function fetchProduct(param) {
		try {
			const productList = await getProductList(param);
			const productOptions = productList?.productWithStockCount?.map((ele) => ({
				key: ele?.product_id,
				value: ele?.product_name,
			}));
			setProductList(productOptions);
		} catch (error) {
			toast.error('Something went wrong! while fetching the product list.');
		}
	}
	async function salesReturnType() {
		try {
			const return_types = await fetchSalesReturnType();
			const returnTypesOptions = return_types?.map((ele) => ({
				key: ele?.id,
				value: ele?.name,
			}));
			setReturnTypeList(returnTypesOptions);
		} catch (error) {
			toast.error('Something went wrong! while fetching the product list.');
		}
	}
	async function fetchInvoiceList() {
		try {
			const param = {
				page: 1,
				page_size: 2000,
				order_by: 'created_at',
				sort_by: 'desc',
				filters: {
					customer_id: customerId,
					dropdownList: 'sales_return',
				},
			};
			const { invoices } = await getInvoicesList(param);
			const invoicesData = invoices?.map((ele) => ({
				key: ele?.id,
				value: ele?.invoice_number,
			}));
			setInvoiceList(invoicesData);
		} catch (error) {
			toast.error(error.message || 'Something went wrong! while fetching the product list.');
		}
	}

	async function handleFetchProductList(invoiceId) {
		try {
			setProductList([]);
			if (invoiceId !== undefined && invoiceId !== '' && invoiceId !== null) {
				const { invoice } = await fetchInvoiceDetails({ ids: [invoiceId] });
				const products =
					invoice.invoice_products?.length > 0
						? invoice.invoice_products?.map((prod) => {
								return {
									key: prod?.product?.product_id,
									value: prod?.product?.product_name,
								};
							})
						: [];
				setProductList(products);
			}
		} catch (error) {
			setBatchList([]);
			toast.error('Something went wrong!');
		}
	}

	async function handleFetchBatchNumber(productId) {
		try {
			setBatchList([]);
			if (productId !== undefined && productId !== '' && productId !== null) {
				const data = await getProductBatchList({ product_id: productId });
				const productBatches =
					data?.length > 0
						? data?.map((batch) => {
								return {
									key: batch?.product_batch_id,
									value: batch?.batch_no,
									qty: batch?.quantity,
									mrp: batch?.mrp,
									expiry_date: getDate(batch?.expiry_date, false, false, true),
								};
							})
						: [];
				setBatchList(productBatches);
			}
		} catch (error) {
			setBatchList([]);
			toast.error('Something went wrong!');
		}
	}

	const handleBatchChange = async (index, value, indexName) => {
		let name = indexName;
		let newRows = [...productTable];
		if (value) {
			if (
				batchList &&
				newRows[index].product_id !== '' &&
				newRows[index].product_id !== undefined
			) {
				const data = await getProductList({
					filterBy: 'product_id',
					filterValue: newRows[index].product_id,
				});
				let batchData = data?.productWithStockCount[0]?.product_batch?.filter(
					(row) => row.batch_no === value,
				);
				if (batchData) {
					newRows[index].expiry_date = batchData[0]?.expiry_date
						? getDate(batchData[0]?.expiry_date, false, false, true)
						: '';
					newRows[index].mrp = batchData[0]?.mrp ?? '0.00';
					newRows[index].product_batch_id = batchData[0]?.product_batch_id;
				} else {
					newRows[index].expiry_date = '';
					newRows[index].mrp = '0.00';
				}
			} else {
				newRows[index].expiry_date = '';
				newRows[index].mrp = '0.00';
			}

			newRows[index][name] = value;
			let rowData = taxesCalculation(newRows, index);

			setProductTable(rowData);
		} else {
			newRows[index].exp_date = '';
			newRows[index].mrp = '0.00';
			newRows[index][name] = value;
			let totalAmount = Number(newRows[index].mrp ?? 0) * Number(newRows[index].quantity ?? 0);

			newRows[index].amount = totalAmount;
			setProductTable(newRows);
		}

		let error = [...tableError.filter((er) => er.name !== 'batch_no')];
		const batchCount = {};
		newRows.forEach((row, i) => {
			if (!row.batch_no) {
				error.push({ index: i, name: 'batch_no' });
			}

			if (row.batch_no) {
				batchCount[row.batch_no] = (batchCount[row.batch_no] || 0) + 1;
			}
		});

		newRows.forEach((row, i) => {
			if (row.batch_no && batchCount[row.batch_no] > 1) {
				error.push({
					index: i,
					name: 'batch_no',
					customErrorMessage: {
						batch_no: 'This batch number already exists in the sales return list.',
					},
				});
			}
		});
		setTableError(error);
	};

	const handleReturnType = (index, value, name) => {
		var errors = [...tableError];
		const newRows = [...productTable];
		if (value) {
			newRows[index][name] = value;
			errors = errors.filter((cell) => !(cell.index === index && cell.name === name));
		} else {
			newRows[index][name] = value;
			errors.push({ index, name: name });
		}
		setTableError(errors);
		setProductTable(newRows);
	};

	const handleInvoiceInputChange = (index, value, name) => {
		var errors = [...tableError];
		const newRows = [...productTable];
		if (value) {
			newRows[index][name] = value;
			newRows[index].product_id = null;
			newRows[index].product_name = '';
			newRows[index].batch_no = '';
			newRows[index].product_batch_id = null;
			newRows[index].mrp = 0;
			newRows[index].expiry_date = null;
			newRows[index].amount = 0;
			errors = errors.filter((cell) => !(cell.index === index && cell.name === name));
		} else {
			newRows[index][name] = value;
			errors.push({ index, name: name });
		}
		setTableError(errors);
		setProductTable(newRows);
	};

	const handleProductInputChange = async (index, value) => {
		setBatchList([]);
		const newRows = [...productTable];
		const selectedProduct = productList?.find((prod) => prod?.key === value);
		newRows[index].product_id = selectedProduct?.key || '';
		newRows[index].product_name = selectedProduct?.value || '';
		var data;
		if (!isNaN(value) && value !== '') {
			data = await getProductList({
				filterBy: 'product_id',
				filterValue: value,
			});
		} else {
			data = null;
		}
		if (data != null && data?.productWithStockCount?.length > 0) {
			newRows[index].product_tax1 = data?.productWithStockCount[0]?.tax1 ?? 0;
			newRows[index].product_tax2 = data?.productWithStockCount[0]?.tax2 ?? 0;
			const batch = data?.productWithStockCount[0]?.product_batch?.map((ele) => ({
				key: ele.product_batch_id,
				value: ele.batch_no,
				qty: ele?.quantity,
				mrp: ele?.mrp,
				expiry_date: getDate(ele?.expiry_date, false, false, true) ?? '',
			}));

			setBatchList(batch || []);
		} else {
			newRows[index].product_tax1 = 0;
			newRows[index].product_tax2 = 0;
			setBatchList([]);
		}

		let error = [...tableError.filter((er) => er.name !== 'product_name')];

		newRows.forEach((row, i) => {
			if (!row.product_id) {
				error.push({ index: i, name: 'product_name' });
			} else {
				error = error.filter((cell) => !(cell.index === index && cell.name === 'product_name'));
			}
		});

		newRows[index].batch_no = '';
		newRows[index].expiry_date = '';
		newRows[index].mrp = 0.0;
		newRows[index].amount = 0;
		setProductTable(newRows);
		setTableError(error);
	};

	const handleChange = (index, valueData, field) => {
		let value = '';

		if (field === 'expiry_date') {
			value = value.replace(/\D/g, '');

			if (value.length > 4) {
				value = value.slice(0, 4);
			}

			if (value.length >= 2) {
				let month = value.slice(0, 2);
				const year = value.slice(2);

				if (parseInt(month) > 12) {
					month = '12';
				}

				value = year ? `${month}/${year}` : month;
			}
		} else if (field === 'quantity') {
			value = valueData?.replace(/[^0-9]/g, '');
		} else {
			value = valueData?.replace(/[^0-9.]/g, '');
			const decimalCount = (value.match(/\./g) || []).length;
			if (decimalCount > 1) {
				value = +value?.slice(0, value.lastIndexOf('.'));
			}
		}

		let errors = [...tableError];
		const newRows = [...productTable];

		if (field === 'expiry_date') {
		}

		if (field === 'mrp') {
			if (value === 0 || value === '') {
				errors.push({ index, name: 'mrp' });
			} else {
				errors = errors.filter((cell) => !(cell.index === index && cell.name === 'mrp'));
			}
			newRows[index].mrp = value;
		}

		if (field === 'quantity') {
			if (value === '' || Number(value) === 0) {
				errors.push({ index, name: field });
			} else {
				errors = errors.filter((cell) => !(cell.index === index && cell.name === field));
			}
		}

		setTableError(errors);

		newRows[index][field] = value;
		let rowData = taxesCalculation(newRows, index);

		setProductTable(rowData);
	};

	const handleKeyDown = (index, event) => {
		let { name, value } = event.target;
		if (event.key === 'Enter') {
			const column = columns.find((col) => col.name === name);
			if (column && column.label === 'QTY') {
				addRow();
			}
		}
	};

	useEffect(() => {
		if (customerId) {
			handleChangeTable();
		}
	}, [customerId]);

	const handleChangeTable = () => {
		salesReturnType();
		fetchInvoiceList();
		if (productTable.length === 0) {
			setProductTable(initialRows);
		}
	};

	const CloseErrorModal = () => {
		setShowError(false);
		setTimeout(() => {
			if (productTable.length > 0) {
				inputRefs.current[productTable.length - 1]?.[0]?.focus();
			}
		}, 0);
	};

	const handleRef = (rowIndex, cellIndex) => (el) => {
		if (!inputRefs.current[rowIndex]) {
			inputRefs.current[rowIndex] = [];
		}

		inputRefs.current[rowIndex][cellIndex] = el;
	};
	const addRow = () => {
		const newRows = [...productTable, initialRows[0]];
		setProductTable(newRows);

		if (newRows.length > 1) {
			const secondLastRowIndex = newRows.length - 2;
			const secondLastRow = newRows[secondLastRowIndex];
			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];

					return (
						(value === null ||
							value === '' ||
							value === '0.00' ||
							value === 'MM/YY' ||
							Number(value) === 0) &&
						['return_type_id', 'invoice_id', 'product_name', 'batch_no', 'quantity'].includes(
							col.name,
						)
					);
				})
				.map((col) => ({
					index: secondLastRowIndex,
					name: col.name,
				}));

			setTableError((prevError) => [
				...prevError.filter(
					(er) =>
						!(
							er.index === secondLastRowIndex &&
							(er.customErrorMessage === null || er.customErrorMessage === undefined)
						),
				),
				...errors,
			]);

			setTimeout(() => {
				inputRefs.current[newRows.length - 1]?.[0]?.focus();
				let lastRowRef = inputRefs.current[newRows.length - 1]?.[0];
				lastRowRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}, 0);
		}
	};

	const deleteRow = (index) => {
		if (productTable.length > 1) {
			const newRows = [...productTable];
			newRows.splice(index, 1);

			// Step 1: Remove old errors and re-index them
			let newTableError = tableError
				.filter((error) => error.index !== index)
				.map((error) => ({
					...error,
					index: error.index > index ? error.index - 1 : error.index,
				}));

			// Step 2: Remove all batch_no errors (we will recalculate)
			newTableError = newTableError.filter((error) => error.name !== 'batch_no');

			// Step 3: Recalculate duplicate batch errors
			const batchCount = {};
			newRows.forEach((row) => {
				if (row.batch_no) {
					batchCount[row.batch_no] = (batchCount[row.batch_no] || 0) + 1;
				}
			});

			newRows.forEach((row, i) => {
				if (row.batch_no && batchCount[row.batch_no] > 1) {
					newTableError.push({
						index: i,
						name: 'batch_no',
						customErrorMessage: {
							batch_no: 'This batch number already exists in the sales return.',
						},
					});
				}
			});

			setTableError(newTableError);
			setProductTable(newRows);
			setTimeout(() => {
				inputRefs.current[newRows.length - 1]?.[0]?.focus();
			}, 0);
		} else if (!id) {
			setProductTable(initialRows);
			setTableError([]);
			setTimeout(() => {
				inputRefs.current[0]?.[0]?.focus();
			}, 0);
		}
	};

	const checkErrorInTable = () => {
		if (productTable?.length > 0 && tableError.length > 0) {
			const secondLastRowIndex = productTable.length - 1;
			const secondLastRow = productTable[secondLastRowIndex];

			const errors = columns
				.filter((col) => {
					const value = secondLastRow[col.name];

					return (
						(value === null || value === '' || value === '0.00' || Number(value) === 0) &&
						['return_type_id', 'invoice_id', 'product_name', 'batch_no', 'quantity'].includes(
							col.name,
						)
					);
				})
				.map((col) => ({
					index: secondLastRowIndex,
					name: col.name,
				}));

			setTableError((prevErrorCells) => [
				...prevErrorCells.filter(
					(er) =>
						!(
							er.index === secondLastRowIndex &&
							(er.customErrorMessage === null || er.customErrorMessage === undefined)
						),
				),
				...errors,
			]);
		}
	};

	return (
		<>
			{tableError && tableError?.length > 0 && (
				<div className="d-flex justify-content-end  text-danger  mb-0">
					{' '}
					<span
						style={{ textDecoration: 'underline', cursor: 'pointer' }}
						onClick={ErrorModalOpen}
					>
						Show all error
					</span>
				</div>
			)}
			<div className="text-center mb-2 custum_table">
				<div>
					<table>
						<thead>
							<tr>
								{columns.map((col) => (
									<th
										style={{
											width:
												(col.name === 'batch_no' && '15%') ||
												(col.name === 'product_name' && '15$'),
										}}
										className={`${className}`}
										key={col.name}
									>
										<div
											style={{
												display: 'flex',
												justifyItems: 'start',
												alignItems: 'center',
											}}
										>
											<span>{col.label}</span>
											<span style={{ color: 'red' }}>
												{[
													'return_type_id',
													'invoice_id',
													'product_name',
													'batch_no',
													'expiry_date',
													'mrp',
													'quantity',
													'amount',
												].includes(col.name)
													? '*'
													: ''}
											</span>
											{[
												'return_type_id',
												'invoice_id',
												'product_name',
												'batch_no',
												'expiry_date',
												'mrp',
												'quantity',
												'amount',
											].includes(col.name) ? (
												<i className="toolTip_custum fa fa-info-circle">
													<span className="toolTip_custumtext">{getToolTipData(col.name)}</span>
												</i>
											) : (
												''
											)}
										</div>
									</th>
								))}
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							{productTable.map((row, rowIndex) => (
								<tr key={rowIndex}>
									{columns.map((col, cellIndex) => (
										<td key={col.name}>
											{col.type === 'return_type' ? (
												<InputSelect
													placeholder="Return Type"
													value={row[col.name]}
													onChange={(value) => {
														handleReturnType(rowIndex, value, col.name);
													}}
													onSelect={(option) => {
														handleReturnType(rowIndex, option.key, col.name);
													}}
													isLocalValidationError={
														tableError.some(
															(cell) => cell.index === rowIndex && cell.name === col.name,
														)
															? true
															: false
													}
													options={returnTypeList}
													returnInputValue={false}
													propInputRef={handleRef(rowIndex, cellIndex)}
												/>
											) : col.type === 'invoice_id' ? (
												<InputSelect
													placeholder="Invoice #"
													value={row[col.name]}
													onChange={(value) => {
														handleInvoiceInputChange(rowIndex, value, col.name);
													}}
													onSelect={(option) => {
														if (option?.key !== row[col.name]) {
															handleInvoiceInputChange(rowIndex, option.key, col.name);
														}
													}}
													isLocalValidationError={
														tableError.some(
															(cell) => cell.index === rowIndex && cell.name === col.name,
														)
															? true
															: false
													}
													options={invoiceList}
													returnInputValue={false}
													propInputRef={handleRef(rowIndex, cellIndex)}
												/>
											) : col.type === 'batch_no' ? (
												<InputSelect
													placeholder="Select Batch No"
													value={
														batchList?.find((option) => option.value === row[col.name])?.value ||
														row[col.name]
													}
													onChange={(value) => {
														handleBatchChange(rowIndex, value, col?.name);
													}}
													onSelect={(option) => {
														handleBatchChange(rowIndex, option.value, col?.name);
													}}
													options={batchList}
													returnInputValue={false}
													isLocalValidationError={
														tableError.some(
															(cell) => cell.index === rowIndex && cell.name === col.name,
														)
															? true
															: false
													}
													onClickDropdownIcon={() => {
														if (row?.product_id !== undefined && row?.product_id !== null) {
															handleFetchBatchNumber(row?.product_id);
														}
													}}
													onfucusCapture={(e) => {
														if (row?.product_id !== undefined && row?.product_id !== null) {
															handleFetchBatchNumber(row?.product_id);
														}
													}}
												/>
											) : col.type === 'product_name' ? (
												<InputSelect
													placeholder="Select Product"
													value={row[col.name]}
													onChange={(value) => {
														if (value === '' || value === null) {
															const newRows = [...productTable];
															newRows[rowIndex].product_id = '';
															newRows[rowIndex].product_name = '';
															setProductTable(newRows);
														}
													}}
													onSelect={(option) => {
														if (option?.value !== row[col.name]) {
															handleProductInputChange(rowIndex, option.key);
														}
													}}
													isLocalValidationError={
														tableError.some(
															(cell) => cell.index === rowIndex && cell.name === col.name,
														)
															? true
															: false
													}
													options={productList}
													returnInputValue={false}
													propInputRef={handleRef(rowIndex, cellIndex)}
													onClickDropdownIcon={() => {
														if (row?.invoice_id !== undefined && row?.invoice_id !== null) {
															handleFetchProductList(row?.invoice_id);
														}
													}}
													onfucusCapture={(e) => {
														if (row?.invoice_id !== undefined && row?.invoice_id !== null) {
															handleFetchProductList(row?.invoice_id);
														}
													}}
												/>
											) : col.type === 'date' ? (
												<input
													type="text"
													name={col.name}
													value={row[col.name]}
													style={{
														border: '1px solid rgba(85, 91, 103, 0.15)',
														borderRadius: '8px',
														height: '38px',
													}}
													onChange={(e) => {
														handleChange(rowIndex, e.target.value, col.name);
													}}
													disabled={true}
													onKeyDown={(e) => handleChange(rowIndex, e.target.value, col.name)}
													placeholder="MM/YY"
													maxLength="5"
													className="table_input"
													ref={handleRef(rowIndex, cellIndex)}
												/>
											) : (
												<input
													className="table_input"
													type={col.type}
													name={col.name}
													value={row[col.name]}
													style={{
														border: tableError.some(
															(cell) => cell.index === rowIndex && cell.name === col.name,
														)
															? '1px solid red'
															: '1px solid rgba(85, 91, 103, 0.15)',
														borderRadius: '8px',
														height: '38px',
													}}
													disabled={col.name === 'mrp' || col.name === 'amount'}
													onChange={(e) => {
														handleChange(rowIndex, e.target.value, col.name);
													}}
													onKeyDown={(e) => {
														handleKeyDown(rowIndex, e);
													}}
													ref={handleRef(rowIndex, cellIndex)}
												/>
											)}
										</td>
									))}

									<td>
										{id !== undefined && productTable.length === 1 ? (
											<></>
										) : (
											<button
												className="delete mt-0 bg-transparent"
												onClick={() => deleteRow(rowIndex)}
												tabIndex="-1"
											>
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
												>
													<path
														d="M3 6H5H21"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M10 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
													<path
														d="M14 11V17"
														stroke="#FF0000"
														strokeWidth="2"
														strokeLinecap="round"
														strokeLinejoin="round"
													/>
												</svg>
											</button>
										)}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>

				{!id && (
					<span style={{ display: 'flex', justifyContent: 'right' }}>
						<button
							className="bg-transparent text-dark add-new-row-button mt-2"
							onClick={addRow}
						>
							Add New Row
							<i
								className="fa fa-plus"
								style={{
									marginLeft: '.5rem',
									strokeWidth: '.1rem',
									color: 'var(--brand-color)',
									WebkitTextStrokeColor: '#fff',
									WebkitTextStrokeWidth: '1px',
								}}
							/>
						</button>
					</span>
				)}
			</div>
			<div className="text-start">
				{showError && (
					<ErrorModal
						show={showError}
						isOpen={showError}
						onClose={CloseErrorModal}
						title="Error in Add Inventory Table"
						error={tableError}
					/>
				)}
			</div>
		</>
	);
};
export default SalesRetuenProductTable;
